<div>
  <div *ngIf="loading; else treeContent">
    <p-skeleton *ngFor="let _ of loadingData" width="100%" height="2rem" class="mb-2 block"></p-skeleton>
  </div>

  <ng-template #treeContent>
    <p-tree [value]="treeNodes" [lazy]="true" [loading]="loading"
      [selectionMode]="configuration.selectionMode || 'single'" loadingMode="icon"
      (onNodeExpand)="onExpandFolder($event)" [(selection)]="selectedNodes">

      <ng-template let-node pTemplate="default">
        <span class="flex align-items-center gap-2">
          <app-file-icon *ngIf="!node.data?.isLoadMore" [fileName]="node.label"></app-file-icon>
          <i *ngIf="node.data?.isLoadMore" [class]="node.data?.icon"></i>
          <span>{{ node.label }}</span>
        </span>
      </ng-template>

    </p-tree>
  </ng-template>

  <div class="col-12 flex justify-content-end mt-2 gap-2">
    <p-button icon="pi pi-refresh" (onClick)="onRefresh()" variant="outlined" title="Reload"></p-button>
    <p-button label="Cancel" (onClick)="onClose()" severity="secondary"></p-button>
    <p-button label="Add" (onClick)="onAdd()"></p-button>
  </div>
</div>
